var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@/components/ui/Button";
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle, } from "@/components/ui/Dialog";
export function DialogSuccess(_a) {
    var message = _a.message, onClose = _a.onClose, showDialog = _a.showDialog, setShowDialog = _a.setShowDialog;
    var openChange = function (open) {
        setShowDialog(open);
        console.log("openChange", open);
        if (!open) {
            onClose();
        }
    };
    return (_jsx(Dialog, __assign({ open: showDialog, onOpenChange: openChange }, { children: _jsxs(DialogContent, __assign({ className: "bg-light-blue-100 sm:max-w-[688px]" }, { children: [_jsx(DialogHeader, __assign({ className: "mb-6 sm:mb-0" }, { children: _jsx(DialogTitle, __assign({ className: "text-[#404040]" }, { children: "Confirma\u00E7\u00E3o" })) })), _jsx("div", __assign({ className: "w-full max-w-[856px] flex flex-col justify-between px-6 py-1 rounded-lg" }, { children: _jsx("div", __assign({ className: "flex justify-center sm:justify-between gap-4" }, { children: _jsx("div", { children: message }) })) })), _jsx(DialogFooter, { children: _jsx(DialogClose, __assign({ asChild: true, className: "flex" }, { children: _jsx(Button, __assign({ type: "button", variant: "link", className: "center max-w-[352px] w-[120px] bg-transparent text-white border-2  border-etipi-blue bg-etipi-blue", onClick: function () { return setShowDialog(false); } }, { children: "Fechar" })) })) })] })) })));
}
